<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import api from "@/axios";
import {getBaseUrl} from "@/helpers/baseUrl";



export default {
  methods: {

    // realizaTeste(){
    //   console.log('realizaTeste')
    //   const query = {}
    //   api.get(`${getBaseUrl()}api/testes`, {
    //     params: { q: query }
    //   }).then((res) => {
    //     console.log('then axios')
    //     console.log(res.data)
    //
    //
    //   })
    // },
    //
    //
    // onComplete: function () {
    //   this.$refs.iswizard.reset();
    // },


  },
  page: {
    title: "Aplicação Testes",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    // vueDropzone: vue2Dropzone,
  },
  mounted() {
    console.log('mounted_testes')
    console.log('realizaTeste')
    const query = {}
    api.get(`${getBaseUrl()}api/testes`, {
      params: { q: query }
    }).then((res) => {
      console.log('then axios')
      console.log(res.data)


    })
  },
  data() {
    return {
      title: "Aplicação Testes",
      items: [
        {
          text: "Crypto",
          href: "/",
        },
        {
          text: "Aplicação Testes",
          active: true,
        },
      ],

    };
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row justify-content-center mt-lg-5">
      <div class="col-xl-5 col-sm-8">
        <div class="card">
          <div class="card-body">
            <div class="text-center">
              <div class="row justify-content-center">
                <div class="col-lg-10">
                  <h4 class="mt-4 fw-semibold">Verificação Testes</h4>
                  <p class="text-muted mt-3">
                    Clique abaixo para realizar a verificação do teste.
                  </p>
                  <div class="mt-4">
                    <!-- Button trigger modal -->
                    <button
                        type="button"
                        class="btn btn-primary"
                        @click="realizaTeste"
                    >
                      Clique aqui para testar
                    </button>
                  </div>
                </div>
                <div class="row justify-content-center mt-5 mb-2">
                  <div class="col-sm-6 col-8">
                    <div>
                      <img
                          src="@/assets/images/verification-img.png"
                          alt
                          class="img-fluid"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


  </Layout>
</template>